import { moduleScnMap } from 'utils/code';
import { getYMDAndTimeFormatDate } from 'utils/getCustomFormatDate';
import { nvl } from 'utils/nvl';

export default function makeDataLevel(d, pageIndex, pageSize, index) {
  return {
    rnum: (pageIndex * pageSize) + index + 1,
    status: d.status,
    modelNo: d.modelNo,
    modelNm: d.modelNm,
    moduleScn: moduleScnMap[d.moduleScn + '']?.title,
    areaNm: nvl(d.areaNm),
    userNm: nvl(d.userNm),
    userPhone: nvl(d.userPhone),
    resolveStatus: d.resolveStatus === 0 ? '문제발생' : '처리완료',
    resolveMemo: nvl(d.resolveMemo),
    regTime: getYMDAndTimeFormatDate(new Date(d.rgstDt))
  }
}